import React from "react";
import { Box, DialogTitle, Typography } from "@mui/material";
import { fieldSx } from "../modules/egresos/components/formStyles";

// Piezas compartidas por los diálogos (Administración de Personal, Flespi…), con el mismo estilo de los demás formularios del sistema
// (campos compactos de /egresos, secciones con barra de título, fondo gris suave y pie separado).
export { fieldSx };

// pt con !important: MUI quita el relleno superior del contenido que sigue al título y la etiqueta del primer campo quedaría cortada
// gridAutoRows max-content: las secciones tienen overflow hidden y, sin esto, la cuadrícula las comprime y quedan cortadas en vez de hacer scroll
export const contenidoSx = { bgcolor: "background.default", p: 1.5, pt: "16px !important", display: "grid", gridAutoRows: "max-content", gap: 1.25, alignContent: "start" };
export const pieSx = { px: 2, py: 1, borderTop: 1, borderColor: "divider" };
export const botonPrincipalSx = { textTransform: "none", fontWeight: 700, minWidth: 130 };

export const Encabezado = ({ titulo, subtitulo }) => (
  <DialogTitle sx={{ py: 1.25, borderBottom: 1, borderColor: "divider" }}>
    <Typography sx={{ fontSize: 17, fontWeight: 800, lineHeight: 1.25 }}>{titulo}</Typography>
    {subtitulo && <Typography sx={{ fontSize: 12, color: "text.secondary" }}>{subtitulo}</Typography>}
  </DialogTitle>
);

// Bloque con título (barra de encabezado + cuerpo)
export const Seccion = ({ titulo, nota, children, sinCuerpo = false }) => (
  <Box sx={{ border: 1, borderColor: "divider", bgcolor: "background.paper", overflow: "hidden", flexShrink: 0 }}>
    <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, px: 1.25, py: 0.4, bgcolor: "action.hover", borderBottom: 1, borderColor: "divider", borderLeft: "3px solid", borderLeftColor: "primary.main" }}>
      <Typography sx={{ fontSize: 11.5, fontWeight: 800, letterSpacing: 0.4, textTransform: "uppercase", color: "primary.main" }}>{titulo}</Typography>
      {nota && <Typography sx={{ fontSize: 11, color: "text.secondary" }}>{nota}</Typography>}
    </Box>
    {sinCuerpo ? children : <Box sx={{ p: 1.25 }}>{children}</Box>}
  </Box>
);

// Cuadrícula de campos dentro de una sección
export const Rejilla = ({ cols = 3, children }) => (
  <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: `repeat(${cols}, minmax(0, 1fr))` }, gap: 1 }}>{children}</Box>
);
